import { Routes } from '@angular/router';
import { authGuard, permissionGuard } from '@abp/ng.core';
import { INVENTORYDATAENTRY_CONFIG } from './inventory-data-entry/inventory-data-entry.config';
import { LIDARINVENTORYDATAENTRY_CONFIG } from './lidar-inventory-data-entry/lidar-inventory-data-entry.config';
import { CALCULATIONRESULT_CONFIG } from './calculation-result/calculation-result.config';
import { DRONEFLIGHT_CONFIG } from './drone-flight/drone-flight.config';
import { TREEDATAINFORMATION_CONFIG } from './tree-data-information/tree-data-information.config';
import { InventoryDataEntry } from './inventory-data-entry/inventory-data-entry';
import { LidarInventoryDataEntry } from './lidar-inventory-data-entry/lidar-inventory-data-entry';
import { CalculationResult } from './calculation-result/calculation-result';
import { DroneFlight } from './drone-flight/drone-flight';
import { TreeDataInformation } from './tree-data-information/tree-data-information';
import { InventoryProjection } from './inventory-projection/inventory-projection';
import { INVENTORY_PROJECTION_CONFIG } from './inventory-projection/inventory-projection.config';
import { inventoryProjectionModalGuard } from './inventory-projection/inventory-projection-modal.guard';

export const INVENTORY_ROUTES: Routes = [
  {
    path: 'inventory-data-entry',
    pathMatch: 'full',
    component: InventoryDataEntry,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INVENTORYDATAENTRY_CONFIG.permission,
      showInMenu: INVENTORYDATAENTRY_CONFIG.showInMenu,
      menuCategory: INVENTORYDATAENTRY_CONFIG.menuCategory,
      menuSubcategory: INVENTORYDATAENTRY_CONFIG.menuSubcategory,
      menuTitle: INVENTORYDATAENTRY_CONFIG.localizationKey,
    },
  },
  {
    path: 'lidar-inventory-data-entry',
    pathMatch: 'full',
    component: LidarInventoryDataEntry,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: LIDARINVENTORYDATAENTRY_CONFIG.permission,
      showInMenu: LIDARINVENTORYDATAENTRY_CONFIG.showInMenu,
      menuCategory: LIDARINVENTORYDATAENTRY_CONFIG.menuCategory,
      menuSubcategory: LIDARINVENTORYDATAENTRY_CONFIG.menuSubcategory,
      menuTitle: LIDARINVENTORYDATAENTRY_CONFIG.localizationKey,
    },
  },
  {
    path: 'calculation-result',
    pathMatch: 'full',
    component: CalculationResult,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CALCULATIONRESULT_CONFIG.permission,
      showInMenu: CALCULATIONRESULT_CONFIG.showInMenu,
      menuCategory: CALCULATIONRESULT_CONFIG.menuCategory,
      menuSubcategory: CALCULATIONRESULT_CONFIG.menuSubcategory,
      menuTitle: CALCULATIONRESULT_CONFIG.localizationKey,
    },
  },
  {
    path: 'drone-flight',
    pathMatch: 'full',
    component: DroneFlight,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: DRONEFLIGHT_CONFIG.permission,
      showInMenu: DRONEFLIGHT_CONFIG.showInMenu,
      menuCategory: DRONEFLIGHT_CONFIG.menuCategory,
      menuSubcategory: DRONEFLIGHT_CONFIG.menuSubcategory,
      menuTitle: DRONEFLIGHT_CONFIG.localizationKey,
    },
  },
  {
    path: 'tree-data-information',
    pathMatch: 'full',
    component: TreeDataInformation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: TREEDATAINFORMATION_CONFIG.permission,
      showInMenu: TREEDATAINFORMATION_CONFIG.showInMenu,
      menuCategory: TREEDATAINFORMATION_CONFIG.menuCategory,
      menuSubcategory: TREEDATAINFORMATION_CONFIG.menuSubcategory,
      menuTitle: TREEDATAINFORMATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'execute-inventory-projection',
    pathMatch: 'full',
    component: InventoryProjection,
    canActivate: [inventoryProjectionModalGuard],
    data: {
      requiredPolicy: INVENTORY_PROJECTION_CONFIG.permission,
      showInMenu: INVENTORY_PROJECTION_CONFIG.showInMenu,
      menuCategory: INVENTORY_PROJECTION_CONFIG.menuCategory,
      menuSubcategory: INVENTORY_PROJECTION_CONFIG.menuSubcategory,
      menuTitle: INVENTORY_PROJECTION_CONFIG.localizationKey,
    },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'inventory-data-entry',
  }
];
